// extracted by mini-css-extract-plugin
export default {"root":"_2FTZ2","cover":"_2ZKEe","middle":"_1KSEy","mature-block":"_16sin","matureBlock":"_16sin","underlay":"_1X3Va"};